// src/components/TabMenu.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const TabMenu = ({ activeTab, onTabChange }) => {
  const navigate = useNavigate();
  
  const handleTabClick = (tab) => {
    if (tab.isLink) {
      navigate(tab.path);
    } else {
      onTabChange(tab.id);
    }
  };
  const tabs = [
    { id: 'search', label: '검색' },
    { id: 'sample', label: '샘플데이터' },
    { id: 'csv', label: 'CSV' },
    { id: 'monitoring', label: '모니터링' },
    { id: 'machine', label: '설비관리', isLink: true, path: '/machine' },
    { id: 'chart', label: '차트' }
  ];

  return (
    <div style={{
      display: 'flex',
      gap: '8px'
    }}>
      {tabs.map(tab => (
        <button
          key={tab.id}
          onClick={() => handleTabClick(tab)}
          style={{
            padding: '8px 16px',
            border: 'none',
            backgroundColor: activeTab === tab.id ? '#007bff' : 'transparent',
            color: activeTab === tab.id ? 'white' : '#666',
            cursor: 'pointer',
            borderRadius: '6px',
            fontWeight: activeTab === tab.id ? '600' : '400',
            fontSize: '14px',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => {
            if (activeTab !== tab.id) {
              e.target.style.backgroundColor = '#f0f0f0';
            }
          }}
          onMouseLeave={(e) => {
            if (activeTab !== tab.id) {
              e.target.style.backgroundColor = 'transparent';
            }
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default TabMenu;